import { render, staticRenderFns } from "./Busse.vue?vue&type=template&id=0bc82fd7&scoped=true&"
import script from "./Busse.vue?vue&type=script&lang=js&"
export * from "./Busse.vue?vue&type=script&lang=js&"
import style0 from "./Busse.vue?vue&type=style&index=0&id=0bc82fd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc82fd7",
  null
  
)

export default component.exports